window.b_first_load = true;

let facetBraSus = false;
let facetPantySus = false;

// seed from remembered customer preference (see assets/base-sus.js)
if (window.getSizeSystemPref) {
    if (window.getSizeSystemPref('bra') === 'sus') facetBraSus = true;
    if (window.getSizeSystemPref('panty') === 'sus') facetPantySus = true;
}

// bra: last band the customer interacted with
let lastActiveBraBand = null;

function getMarketLabel() {
    return document.querySelector('[data-sus-size-facets-container]')?.dataset.marketLabel || 'EU';
}

function updateActiveChipLabels() {
    document.querySelectorAll('[data-js-active-size]').forEach(span => {
        const isSus = span.dataset.jsActiveSize === 'bra' ? facetBraSus : facetPantySus;
        span.textContent = isSus ? (span.dataset.sus || span.dataset.market) : span.dataset.market;
    });

    // panty: multiple eu sizes can share one SUS label
    if (facetPantySus) {
        const susCounts = {};
        document.querySelectorAll('[data-facet-size-panty] label[data-market]').forEach(label => {
            if (label.dataset.sus) susCounts[label.dataset.sus] = (susCounts[label.dataset.sus] || 0) + 1;
        });
        const marketLabel = getMarketLabel();
        document.querySelectorAll('[data-js-active-size="panty"]').forEach(span => {
            if (susCounts[span.dataset.sus] > 1) {
                span.innerHTML = `${span.dataset.sus} <small>${marketLabel} ${span.dataset.market}</small>`;
            }
        });
    }
}

// prevent UI-only inputs (band radios, size toggles) from triggering facet form AJAX
document.addEventListener('input', e => {
  if (e.target.getAttribute('form') === 'sus-ui-only') e.stopPropagation();
}, true);

// prevent menu drawer generic submenu throwing an error on missing button layout element
document.addEventListener('click', e => {
  if (e.target.closest('[data-facets-calc-wrapper] summary')) e.stopPropagation();
}, true);

// bra: reset cup group visibility
function resetParentState() {
    checkBraDisabledState();
    const collection_type_bra = document.querySelector('[data-js-facets-bra]');
    if (!collection_type_bra) return;
    collection_type_bra.querySelectorAll('[data-js-size-children]').forEach(elem => {
        elem.classList.remove('active');
    });
}

// bra: select band from URL params
function setUrlVariant() {
    const currUrlParams = new URLSearchParams(window.location.search);
    const currUrlVariantBra = currUrlParams.get('filter.v.m.filtergroesse.bhs');

    if (currUrlVariantBra) {
        const sParamBand = currUrlVariantBra.replace(/[A-Za-z]+$/, '');
        const oTargetInput = document.querySelector(`input[data-js-parent-size="${sParamBand}"]`);
        if (oTargetInput) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    oTargetInput.checked = true;
                    BandSizeSelection(oTargetInput);
                });
            });
        }
    }
}

// bra: adjustments on load
function FacetSizeLoad() {
    const collection_type_bra = document.querySelector('[data-js-facets-bra]');
    if (!collection_type_bra || !window.b_first_load) return;

    checkBraDisabledState();

    // bra: restore cup visibility without selection change
    const currentBand = document.querySelector('input[data-js-parent-size]:checked');
    if (currentBand) {
        BandSizeSelection(currentBand);
        window.b_first_load = false;
        return;
    }

    // filter got re-rendered, prepare correct state
    let firstCheckedInput = null;
    let preferredCheckedInput = null;

    collection_type_bra.querySelectorAll('[data-js-size-children]').forEach(elem => {
        
        const iParent = elem.getAttribute('data-js-size-children');
        const bandInput = document.querySelector(`input[data-js-parent-size="${iParent}"]`);
        if (!bandInput) return;

        const hasChecked = elem.querySelectorAll('[data-js-size-btn-child]:checked').length > 0;
        if (hasChecked) {
            if (!firstCheckedInput) firstCheckedInput = bandInput;
            if (iParent === lastActiveBraBand) preferredCheckedInput = bandInput;
        }
    });

    const targetInput = preferredCheckedInput || firstCheckedInput;

    if (targetInput) {
        targetInput.checked = true;
        BandSizeSelection(targetInput);
    } else {
        // no cup checked? default state
        setUrlVariant();
    }
    window.b_first_load = false;
}

// bra: band selection — elem is the radio input
function BandSizeSelection(elem) {
    resetParentState();

    // a real band is now resolved — hide the static "all cups" showcase and undim its legend
    document.querySelector('[data-facet-cup-showcase]')?.setAttribute('hidden', '');
    document.querySelector('[data-facet-cup-legend]')?.classList.remove('legend_disabled');

    const collection_type_bra = document.querySelector('[data-js-facets-bra]');
    if (!collection_type_bra) return;

    const size = elem.getAttribute('data-js-parent-size');
    const target = collection_type_bra.querySelector(`[data-js-size-children="${size}"]`);
    if (!target) return;

    target.classList.add('active');
    collection_type_bra.querySelector('[data-js-size-subselection]')?.classList.add('active');
}

let bandCheckedBeforeClick = null;

document.addEventListener('mousedown', e => {
    const label = e.target.closest('[data-js-size-btn-parent]');
    bandCheckedBeforeClick = (label && label.control && label.control.checked) ? label.control : null;
}, true);

document.addEventListener('click', e => {
    const label = e.target.closest('[data-js-size-btn-parent]');
    if (!label) return;
    const input = label.control;
    if (input && input === bandCheckedBeforeClick) {
        e.preventDefault();
        // leave cup buttons unchanged, remove band active visual
        input.checked = false;
        updateBandHasSelection();
    }
}, true);

// bra: mark bands that have active cup selections (but are not currently focused)
function updateBandHasSelection() {
    document.querySelectorAll('input[data-js-parent-size]').forEach(input => {
        const band = input.getAttribute('data-js-parent-size');
        const cupGroup = document.querySelector(`[data-js-size-children="${band}"]`);
        const hasChecked = cupGroup ? cupGroup.querySelectorAll('[data-js-size-btn-child]:checked').length > 0 : false;
        input.nextElementSibling?.classList.toggle('has-selection', hasChecked);
    });
}

// calculator: applying a calculated bra size is disabled while a panty filter is active, and vice versa
function updateSizecalcApplyExclusivity() {
    const isBraActive = document.querySelectorAll('[data-facet-size-bra] [data-js-size-btn-child]:checked').length > 0;
    const isPantyActive = document.querySelectorAll('[data-facet-size-panty] input[type="checkbox"]:checked').length > 0;

    document.querySelectorAll('[data-js-action-bra]').forEach(btn => {
        btn.classList.toggle('is-sizecalc-disabled', isPantyActive);
        btn.setAttribute('aria-disabled', isPantyActive);
    });
    document.querySelectorAll('[data-js-action-panty]').forEach(btn => {
        btn.classList.toggle('is-sizecalc-disabled', isBraActive);
        btn.setAttribute('aria-disabled', isBraActive);
    });
}


// panty/int disabling each other
function updatePantyIntExclusivity() {
    const pantyInputs = [...document.querySelectorAll('[data-facet-size-panty] input[type="checkbox"]')];
    const intInputs = [...document.querySelectorAll('[data-facet-size-int] input[type="checkbox"]')];

    const isPantyActive = pantyInputs.some(i => i.checked);
    const isIntActive = intInputs.some(i => i.checked);

    const applyExclusivity = (inputs, disable) => {
        inputs.forEach(input => {
            if (input.checked) return;
            if (disable) {
                input.disabled = true;
                input.dataset.crossDisabled = 'true';
                document.querySelector('[data-facet-cup-showcase]')?.classList.add('disabled');
            } else if (input.dataset.crossDisabled) {
                input.disabled = false;
                delete input.dataset.crossDisabled;
                document.querySelector('[data-facet-cup-showcase]')?.classList.remove('disabled');
            }
            document.querySelector(`label[for="${input.id}"]`)?.classList.toggle('disabled', input.disabled);
        });
    };

    applyExclusivity(intInputs, isPantyActive);
    applyExclusivity(pantyInputs, isIntActive);
}

// bra: delegate band radio changes + cup checkbox changes
document.addEventListener('change', e => {
    if (e.target.matches('input[data-js-parent-size]')) BandSizeSelection(e.target);
    if (e.target.matches('[data-js-size-btn-child]')) {
        updateBandHasSelection();
        lastActiveBraBand = e.target.closest('[data-js-size-children]')?.getAttribute('data-js-size-children') ?? lastActiveBraBand;
    }
    if (e.target.matches('[data-js-size-btn-child]') || e.target.matches('[data-facet-size-panty] input[type="checkbox"]')) updateSizecalcApplyExclusivity();
});

// bra: disabled state
function checkBraDisabledState() {
    const container_bra = document.querySelector('[data-js-facets-bra]');
    if (!container_bra) return;

    const iBraChildrenTotal = container_bra.querySelectorAll('[data-js-size-btn-child]').length;
    const iBraChildrenDisabled = container_bra.querySelectorAll('[data-js-size-btn-child]:disabled').length;
    const isDisabled = iBraChildrenDisabled >= iBraChildrenTotal;

    document.querySelector('[data-js-facets-band]')?.classList.toggle('disabled', isDisabled);

    // mark individual bands without available cup sizes
    document.querySelectorAll('input[data-js-parent-size]').forEach(input => {
        const band = input.getAttribute('data-js-parent-size');
        const cups = [...(document.querySelector(`[data-js-size-children="${band}"]`)?.querySelectorAll('[data-js-size-btn-child]') || [])];
        const bandDisabled = cups.length > 0 && cups.every(cup => cup.disabled);
        input.nextElementSibling?.classList.toggle('disabled', bandDisabled);
    });
}

// size sections: check disabled state on facet opening or after re-render
function checkSizeFacetState(e) {
    const sectionConfigs = [
        { selector: '[data-facet-size-bra]',   inputType: 'checkbox' },
        { selector: '[data-facet-size-panty]', inputType: 'checkbox' },
        { selector: '[data-facet-size-int]',   inputType: 'checkbox' },
    ];

    // must run before the disabled-state snapshot below — panty/int cross-disabling is JS-driven
    updatePantyIntExclusivity();

    sectionConfigs.forEach(({ selector, inputType }) => {
        const section = document.querySelector(selector);
        if (!section) return;

        const inputs = [...section.querySelectorAll(`input[type="${inputType}"]`)];
        const sectionDisabled = inputs.length > 0 && inputs.every(i => i.disabled);

        section.classList.toggle('disabled', sectionDisabled);
        section.querySelector('[data-facets-calc-wrapper]')?.classList.toggle('disabled', sectionDisabled);
    });

    // also reflect disabled state on the band fieldset
    checkBraDisabledState();

    updateActiveChipLabels();

    // restoreToggleState/FacetSizeLoad resync the view to the applied filter after an AJAX re-render —
    // they read stale local/URL state mid-click (checkSizeFacetState fires on every click via onclick) - 
    // called with no event and never from a live click. (setUrlVariant can't override an already-resolved band)
    if (!e) {
        if (window.b_first_load) restoreToggleState();
        FacetSizeLoad();
    }
    updateBandHasSelection();
    updateSizecalcApplyExclusivity();
}

function applyPantyToggle(isSus) {
    // multiple EU sizes can share a single SUS label (our SUS system spans 2 EU sizes per step)
    const labels = [...document.querySelectorAll('[data-facet-size-panty] label[data-market]')];
    const susCounts = {};
    labels.forEach(label => {
        if (label.dataset.sus) susCounts[label.dataset.sus] = (susCounts[label.dataset.sus] || 0) + 1;
    });

    const marketLabel = getMarketLabel();
    labels.forEach(label => {
        const span = label.querySelector('span');
        if (isSus && susCounts[label.dataset.sus] > 1) {
            span.innerHTML = `${label.dataset.sus} <small>${marketLabel} ${label.dataset.market}</small>`;
        } else {
            span.textContent = isSus ? label.dataset.sus : label.dataset.market;
        }
    });
    const sLabelKey = isSus ? 'sus' : 'std';
    document.querySelectorAll('[data-toggle-labels-panty]').forEach(el => el.textContent = el.getAttribute(`data-label-${sLabelKey}`));
    document.querySelector('.size-wrapper-panty')?.classList.toggle('sus-toggled', isSus);
}

function applyBraToggle(isSus) {
    document.querySelectorAll('[data-facet-size-bra] label[data-market]').forEach(label => {
        label.querySelector('span').textContent = isSus ? label.dataset.sus : label.dataset.market;
    });
    document.querySelectorAll('[data-facet-size-bra] .size-variant-wrapper').forEach(wrapper => {
        wrapper?.classList.toggle('sus-toggled', isSus);
    });
    const sLabelKey = isSus ? 'sus' : 'std';
    document.querySelectorAll('[data-toggle-labels-bra]').forEach(el => el.textContent = el.getAttribute(`data-label-${sLabelKey}`));

    // cup showcase: std/sus with 2 separate sets (sus translates into different button count)
    const showcaseStd = document.querySelector('[data-facet-cup-showcase-group="std"]');
    const showcaseSus = document.querySelector('[data-facet-cup-showcase-group="sus"]');
    if (showcaseStd) showcaseStd.hidden = isSus;
    if (showcaseSus) showcaseSus.hidden = !isSus;
}

function restoreToggleState() {
    if (facetPantySus) {
        const input = document.querySelector('[data-facet-toggle-system][value="sus"]');
        if (input) input.checked = true;
        applyPantyToggle(true);
    }
    if (facetBraSus) {
        const input = document.querySelector('[data-facet-bra-toggle-system][value="sus"]');
        if (input) input.checked = true;
        applyBraToggle(true);
    }
}

// apply memorized size system pref on load (independet of re-render)
document.addEventListener('DOMContentLoaded', () => {
    if (facetBraSus || facetPantySus) restoreToggleState();
});

// bra/panty size system toggle syncing
function applyFacetSizeSystemSync(isSus) {
    facetBraSus = isSus;
    facetPantySus = isSus;

    const sValue = isSus ? 'sus' : 'std';
    const braToggle = document.querySelector(`[data-facet-bra-toggle-system][value="${sValue}"]`);
    if (braToggle) braToggle.checked = true;
    applyBraToggle(isSus);

    const pantyToggle = document.querySelector(`[data-facet-toggle-system][value="${sValue}"]`);
    if (pantyToggle) pantyToggle.checked = true;
    applyPantyToggle(isSus);

    updateActiveChipLabels();
    if (window.setSizeSystemPref) window.setSizeSystemPref('bra', sValue);
}

// panty/bra size system toggle (eu/sus) | document helps listeners survive re-renders of facets
document.addEventListener('change', e => {
    if (e.target.matches('[data-facet-toggle-system]') || e.target.matches('[data-facet-bra-toggle-system]')) {
        applyFacetSizeSystemSync(e.target.value === 'sus');
    }
});

// facets drawer: scroll lock + wheel redirect (same pattern as size/cart drawers)
document.addEventListener('DOMContentLoaded', () => {
  const facetsWrapper = document.querySelector('.mobile-facets__wrapper');
  if (!facetsWrapper) return;
  const details = facetsWrapper.querySelector('details.disclosure-has-popup');
  const scrollContainer = facetsWrapper.querySelector('.mobile-facets__inner');
  if (!details || !scrollContainer) return;

  function onWheel(e) {
    if (!scrollContainer.contains(e.target)) {
      e.preventDefault();
      scrollContainer.scrollTop += e.deltaY;
    }
  }

  new MutationObserver(() => {
    if (details.hasAttribute('open')) {
      document.documentElement.classList.add('overflow-hidden');
      facetsWrapper.addEventListener('wheel', onWheel, { passive: false });
    } else {
      document.documentElement.classList.remove('overflow-hidden');
      facetsWrapper.removeEventListener('wheel', onWheel);
    }
  }).observe(details, { attributes: true, attributeFilter: ['open'] });
});

// size facets: sync disabled/note state (on open, not every click)
// (disabled attributes only ever change via an AJAX re-render, which resyncs independently below)
document.addEventListener('DOMContentLoaded', () => {
    const sizeFacetDetails = document.querySelector('.js-filter[data-index="mobile-0"]');
    if (!sizeFacetDetails) return;
    sizeFacetDetails.addEventListener('toggle', () => {
        if (sizeFacetDetails.open) checkSizeFacetState();
    });
});

// show/hide disabled note on opening other facets
function checkOtherFacetState(el) {
    const o_child = document.getElementById(el);
    if (!o_child) return;

    const o_el_notice = o_child.querySelector('[data-js-size-facets-note-all]');
    const total = o_child.querySelectorAll('.mobile-facets__label').length;
    const disabled = o_child.querySelectorAll('.mobile-facets__label--disabled').length;

    o_el_notice?.classList.toggle('active', disabled >= total);
}
